<div class="filter-group">
  <div *ngFor="let rule of filter.rules; let i = index" class="rule-row">
    <!-- Condition Dropdown (not shown for first rule) -->
    <mat-form-field class="condition" appearance="fill" *ngIf="i > 0">
      <mat-label>Condition</mat-label>
      <mat-select [(ngModel)]="rule.condition" (selectionChange)="updateCondition($event.value, filter, i)">
        <mat-option value="AND">AND</mat-option>
        <mat-option value="OR">OR</mat-option>
        <mat-option value="AND NOT">AND NOT</mat-option>
        <mat-option value="OR NOT">OR NOT</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="isFilterRule(rule)">
      <!-- Field Selection -->
      <mat-form-field class="field" appearance="fill">
        <mat-label>Field</mat-label>
        <mat-select [(ngModel)]="rule.field" (selectionChange)="updateRuleType(rule)">
          <mat-option *ngFor="let column of dynamicFilterField" [value]="column.name">
            {{ column.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Operator Selection -->
      <mat-form-field class="operator" appearance="fill">
        <mat-label>Operator</mat-label>
        <mat-select [(ngModel)]="rule.operator">
          <ng-container *ngIf="rule.type === 'text'">
            <mat-option *ngFor="let op of textOperators" [value]="op">{{ op }}</mat-option>
          </ng-container>
          <ng-container *ngIf="rule.type === 'number'">
            <mat-option *ngFor="let op of numberOperators" [value]="op">{{ op }}</mat-option>
          </ng-container>
          <ng-container *ngIf="rule.type === 'date'">
            <mat-option *ngFor="let op of dateOperators" [value]="op">{{ op }}</mat-option>
          </ng-container>
          <ng-container *ngIf="rule.type === 'boolean'">
            <mat-option *ngFor="let op of booleanOperators" [value]="op">{{ op }}</mat-option>
          </ng-container>
          <ng-container *ngIf="rule.type === 'dropdown'">
            <mat-option *ngFor="let op of dropdownOperators" [value]="op">{{ op }}</mat-option>
          </ng-container>
          <ng-container *ngIf="rule.type === 'select'">
            <mat-option *ngFor="let op of dropdownOperators" [value]="op">{{ op }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <!-- Value: text / number / boolean -->
      <mat-form-field class="value" appearance="fill"
        *ngIf="rule.type !== 'dropdown' && rule.type !== 'date' && rule.type !== 'select'">
        <mat-label>Value</mat-label>
        <input matInput [(ngModel)]="rule.value" type="text" />
      </mat-form-field>

      <!-- Value: dropdown (paginated API) -->
      <mat-form-field class="value" appearance="fill" *ngIf="rule.type === 'dropdown'">
        <mat-label>Value</mat-label>
        <mat-select [(ngModel)]="rule.value" [attr.data-key]="'dropdown_' + rule.field">
          <input matInput type="text" [formControl]="searchControl" (keydown)="$event.stopPropagation()">
          <mat-option *ngFor="let option of (dropdownStreams[rule.field] | async) || []"
            [value]="option.id">
            {{ getOptionLabel(rule.field, option) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Value: static select -->
      <mat-form-field class="value" appearance="fill" *ngIf="rule.type === 'select'">
        <mat-label>Value</mat-label>
        <mat-select [(ngModel)]="rule.value">
          <mat-option *ngFor="let opt of getStaticValues(rule.field)" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Value: date -->
      <mat-form-field class="value" appearance="fill" *ngIf="rule.type === 'date'">
        <input matInput [matDatepicker]="picker" [(ngModel)]="rule.value" placeholder="Choose a date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <!-- Remove Rule -->
      <button class="remove-btn" mat-icon-button color="warn" (click)="removeRule(filter, i)" aria-label="Remove rule">
        <mat-icon>delete</mat-icon>
      </button>
    </ng-container>
  </div>

  <!-- Action Buttons -->
  <div class="filter-actions">
    <button (click)="addRule(filter)" type="button" class="secondary-button filter-btn" mat-flat-button>
      + Add Rule
    </button>
    <button (click)="submitFilter()" type="button" class="secondary-button filter-btn" mat-stroked-button>
      Apply Filter
    </button>
  </div>
</div>
